import Can from 'components/Can/Can';
import { DACA_PERMISSIONS } from 'constants/index';
import React, { Component } from 'react';
import DropdownFilter from '../../../components/DropdownFilter/dropdownFilter.component';
import Table from '../../../components/Table/table.component';
import dacaService from '../../../services/dacaService';
import historicoDacaService from '../../../services/historicoDacaService';
import ToastHelper from '../../../utils/toastHelper';
import CancelarModal from '../../comum/modais/cancelar.modal';
import ModalEditarTransacao from '../editarHistoricoDACA/editarHistoricoDACA.modal';
import ModalVisualizarTransacao from '../visualizarHistoricoDaca/visualizaHistoricoDaca.modal';
import PesquisaAvancadaHistoricoDaca from './pesquisaAvancadaHistoricoDaca';

class ListarHistoricoDaca extends Component {
	state = {
		filtro: {
			tipos: ['ENTRADA', 'SAIDA', 'MOVIMENTACAO', 'DEVOLUCAO', 'DESCARTE', 'RESERVA_PDR', 'SAIDA_PDR'],
			pagina: 0,
			idDaca: null,
		},
		lista: {
			content: [],
			pageable: {
				sort: {
					unsorted: true,
					sorted: false,
				},
				pageSize: 15,
				pageNumber: 0,
				offset: 0,
				unpaged: false,
				paged: true,
			},
			last: true,
			totalPages: 1,
			totalElements: 1,
			numberOfElements: 1,
			first: true,
			sort: {
				unsorted: true,
				sorted: false,
			},
			size: 15,
			number: 0,
		},
		isOpenVisualizar: false,
		isOpenEditarTransacao: false,
		isOpenCancelarTransacao: false,
		transacaoSelecionada: {
			ocorrencia: {
				id: null,
			},
		},
		daca: {},
		pesquisaAvancada: false,
		tiposTransacaoPermanente: [
			{
				id: 'ENTRADA',
				nome: 'Entrada',
			},
			{
				id: 'SAIDA',
				nome: 'Empréstimo',
			},
			{
				id: 'DESCARTE',
				nome: 'Descarte',
			},
			{
				id: 'DEVOLUCAO',
				nome: 'Devolução',
			},
			{
				id: 'SAIDA_PDR',
				nome: 'Saída-PDR',
			},
			{
				id: 'RESERVA_PDR',
				nome: 'Reserva-PDR',
			},
			{
				id: 'MOVIMENTACAO',
				nome: 'Movimentação',
			},
		],
		tiposTransacaoNaoPermante: [
			{
				id: 'ENTRADA',
				nome: 'Entrada',
			},
			{
				id: 'SAIDA',
				nome: 'Saída',
			},
			{
				id: 'SAIDA_PDR',
				nome: 'Saída-PDR',
			},
			{
				id: 'RESERVA_PDR',
				nome: 'Reserva-PDR',
			},
			{
				id: 'MOVIMENTACAO',
				nome: 'Movimentação',
			},
		],
	}

	columnsHistorico = [
		{ id: 0, title: 'Transação', property: 'tipoTransacao' },
		{ id: 1, title: 'Entrada/Saída', property: 'quantidadeEntradaSaida' },
		{ id: 2, title: 'Data', property: 'dataCadastro' },
		{ id: 3, title: 'Origem', property: 'origemGridListagemHistorico' },
		{ id: 4, title: 'Destino', property: 'destinoGridListagemHistorico' },
	];

	actionsHistorico = [
		{
			id: 0,
			name: 'Visualizar',
			icon: 'fas fa-search',
			action: item => this.handleVisualizarTransacao(item),
		},
		{
			id: 1,
			name: 'Editar',
			icon: 'fas fa-edit',
			action: item => this.handleEditarTransacao(item),
			show: (item) => {
				const { daca } = this.props;
				return (!item.cancelado && daca.ultimoIdHistorico === item.id && !item.isPDR);
			},
			checkRule: true,
		},
		{
			id: 2,
			name: 'Cancelar',
			icon: 'fas fa-times',
			action: item => this.handleCancelarTransacao(item),
			show: (item) => {
				const { daca } = this.props;
				return (!item.cancelado && daca.ultimoIdHistorico === item.id && !item.isPDR);
			},
			checkRule: true,
		},
	];

	actionsHistoricoVisualizar = [
		{
			id: 0,
			name: 'Visualizar',
			icon: 'fas fa-search',
			action: item => this.handleVisualizarTransacao(item),
		},
	];

	componentDidMount() {
		const { daca } = this.props;

		const newState = this.state;
		newState.filtro.idDaca = daca.id;
		newState.daca = daca;
		this.setState(daca);

		this.initialize();
	}

	handleChangeCheckboxGroup = (value) => {
		const filter = value.map(f => f.id);

		const newState = this.state;
		newState.filtro.tipos = filter;
		newState.filtro.pagina = 0;
		this.setState(newState);

		this.initialize();
	}

	handlePageChangeHistorico = (pagina) => {
		const newState = this.state;
		newState.filtro.pagina = pagina;
		this.setState(newState);

		this.initialize();
	}

	/* VISUALIZAR TRANSAÇÃO */
	handleVisualizarTransacao = async (transacao) => {
		const response = await historicoDacaService.findById(transacao.id);

		this.setState({ transacaoSelecionada: response.data });

		this.handleOpenVisualizar();
	}

	createModalVisualizar = (item, { isOpenVisualizar, transacaoSelecionada, daca } = this.state) => (
		isOpenVisualizar && (
			<ModalVisualizarTransacao
				isOpenVisualizar={isOpenVisualizar}
				handleCloseVisualizar={this.handleCloseVisualizar}
				transacao={transacaoSelecionada}
				isDacaPermanente={daca.permanente}
			/>
		)
	);

	handleOpenVisualizar = () => {
		this.setState({ isOpenVisualizar: true });
	};

	handleCloseVisualizar = () => {
		this.setState({ isOpenVisualizar: false });
	};

	/* CANCELAR TRANSAÇÃO */
	handleCancelarTransacao = (item) => {
		this.setState({ isOpenCancelarTransacao: true });
		this.createModalCancelarTransacao(item, this.state);
	}

	createModalCancelarTransacao = (item, { isOpenCancelarTransacao }) => (
		isOpenCancelarTransacao && (
			<CancelarModal
				isOpenCancelar={isOpenCancelarTransacao}
				handleCloseCancelar={() => this.setState(
					prevState => ({ prevState, isOpenCancelarTransacao: false }),
				)}
				handleSubmitCancelar={() => this.handleSubmitCancelarTransacao(item)}
			/>
		)
	);

	handleSubmitCancelarTransacao = async (item) => {
		const { handleSubmit } = this.props;

		await dacaService.cancelarTransacao(item);
		ToastHelper.success('Transação cancelada com sucesso.');
		this.setState(prevState => ({ prevState, isOpenCancelarTransacao: false }));

		handleSubmit();
	}

	/* EDITAR TRANSAÇÃO */
	handleEditarTransacao = async (transacao) => {
		const response = await historicoDacaService.findEditarById(transacao.id);
		this.setState({ transacaoSelecionada: response.data });

		if (response.data.ocorrencia === null) {
			// Necessário para não bugar o schema de validação quando a ocorrencia é nula
			this.setState(prevState => ({
				transacaoSelecionada: {
					...prevState.transacaoSelecionada,
					ocorrencia: {
						id: '',
					},
				},
			}));
		}

		if (response.data.destinoEstoque && response.data.destinoEstoque.validade === null) {
			this.setState(prevState => ({
				transacaoSelecionada: {
					...prevState.transacaoSelecionada,
					destinoEstoque: {
						...prevState.transacaoSelecionada.destinoEstoque,
						validade: undefined,
					},
				},
			}));
		}

		if (response.data.destinoEstoque && response.data.destinoEstoque.valorUnitario === null) {
			this.setState(prevState => ({
				transacaoSelecionada: {
					...prevState.transacaoSelecionada,
					destinoEstoque: {
						...prevState.transacaoSelecionada.destinoEstoque,
						valorUnitario: '',
					},
				},
			}));
		}

		this.handleOpenEditarTransacao();
	}

	createModalEditarTransacao = ({
		isOpenEditarTransacao,
		transacaoSelecionada,
		daca,
	}) => (
		isOpenEditarTransacao && (
			<ModalEditarTransacao
				isOpenEditarTransacao={isOpenEditarTransacao}
				handleCloseEditarTransacao={this.handleCloseEditarTransacao}
				handleSubimitEditarTransacao={this.handleSubimitEditarTransacao}
				transacao={transacaoSelecionada}
				handleSalvarTransacao={this.handleSalvarTransacao}
				idDaca={daca.id}
				daca={daca}
			/>
		)
	);

	handleOpenEditarTransacao = () => {
		this.setState({ isOpenEditarTransacao: true });
	};

	handleCloseEditarTransacao = () => {
		this.setState({ isOpenEditarTransacao: false });
	};

	handleSubimitEditarTransacao = async (values) => {
		const { transacaoSelecionada, dacaId } = this.state;
		const { handleSubmit } = this.props;

		switch (transacaoSelecionada.tipoTransacao) {
		case 'ENTRADA':
			await dacaService.editarTransacaoEntrada(values);
			this.handleCloseEditarTransacao();
			ToastHelper.success('Edição concluída com sucesso.');
			handleSubmit();
			break;
		case 'SAIDA':
			await dacaService.editarTransacaoSaida(values);
			this.handleCloseEditarTransacao();
			ToastHelper.success('Edição concluída com sucesso.');
			handleSubmit();
			break;
		case 'DESCARTE':
			await dacaService.editarTransacaoSaida(values);
			this.handleCloseEditarTransacao();
			ToastHelper.success('Edição concluída com sucesso.');
			handleSubmit();
			break;
		case 'MOVIMENTACAO':
			await historicoDacaService.editMovimentacao({
				...values,
				idDaca: dacaId,
			});
			this.handleCloseEditarTransacao();
			ToastHelper.success('Edição concluída com sucesso.');
			handleSubmit();
			break;
		case 'DEVOLUCAO':
			await dacaService.editarTransacaoDevolucao(values);
			this.handleCloseEditarTransacao();
			ToastHelper.success('Edição concluída com sucesso.');
			handleSubmit();
			break;
		default:
			break;
		}
	}

	pesquisaSimples = () => {
		const {
			pesquisaAvancada,
			filtro,
			daca,
			tiposTransacaoPermanente,
			tiposTransacaoNaoPermante,
		} = this.state;

		return !pesquisaAvancada && (
			<React.Fragment>
				<div className='d-flex'>
					<div className='col-3 pl-0'>
						<button type='button' onClick={() => { this.setState({ pesquisaAvancada: true }); }} className='btn btn-link pl-0'>Pesquisa avançada</button>
					</div>
					{daca.permanente && (
						<div className='col-md-9 pr-0'>
							<DropdownFilter
								handleChangeCheckboxGroup={this.handleChangeCheckboxGroup}
								filtro={
									filtro.tipos.map(item => ({
										id: item,
									}))
								}
								checkboxValuesList={tiposTransacaoPermanente}
								id='historicoDaca'
								name='historicoDaca'
								keyName='historicoDaca'
								notObjectValue
							/>
						</div>
					)}
					{!daca.permanente && (
						<div className='col-md-9 pr-0'>
							<DropdownFilter
								handleChangeCheckboxGroup={this.handleChangeCheckboxGroup}
								filtro={
									filtro.tipos.map(item => ({
										id: item,
									}))
								}
								checkboxValuesList={tiposTransacaoNaoPermante}
								id='historicoDaca'
								name='historicoDaca'
								keyName='historicoDaca'
								notObjectValue
								styleInput
							/>
						</div>
					)}
				</div>
			</React.Fragment>
		);
	}

	pesquisaAvancada = () => {
		const {
			pesquisaAvancada,
			daca,
			tiposTransacaoPermanente,
			tiposTransacaoNaoPermante,
		} = this.state;

		return pesquisaAvancada && (
			<PesquisaAvancadaHistoricoDaca
				handleSearch={(values) => {
					this.setState({
						filtro: {
							...values,
							pagina: 0,
							simplificado: false,
							idDaca: daca.id,
						},
					});
					this.initialize();
				}}
				handleClear={() => {
					const newState = this.state;
					newState.filtro.tipos = ['ENTRADA', 'SAIDA', 'MOVIMENTACAO', 'DEVOLUCAO', 'DESCARTE', 'RESERVA_PDR', 'SAIDA_PDR'];
					newState.filtro.pagina = 0;
					newState.filtro.simplificado = false;
					newState.filtro.destino = '';
					newState.filtro.origem = '';
					newState.filtro.dataInicial = undefined;
					newState.filtro.dataFinal = undefined;

					this.setState(newState);
					this.initialize();
				}}
				handlePesquisaSimplificada={() => {
					const newState = this.state;
					newState.filtro.tipos = ['ENTRADA', 'SAIDA', 'MOVIMENTACAO', 'DEVOLUCAO', 'DESCARTE', 'RESERVA_PDR', 'SAIDA_PDR'];
					newState.filtro.pagina = 0;
					newState.filtro.simplificado = undefined;

					this.setState(newState);
					this.setState({ pesquisaAvancada: false });
					this.initialize();
				}}
				tiposTransacao={daca.permanente ? tiposTransacaoPermanente : tiposTransacaoNaoPermante}
				dacaId={daca.id}
			/>
		);
	}

	async initialize(resetFilter = false) {
		if (resetFilter) {
			const newState = this.state;
			const wasAvancada = newState.pesquisaAvancada;

			newState.filtro.tipos = ['ENTRADA', 'SAIDA', 'MOVIMENTACAO', 'DEVOLUCAO', 'DESCARTE', 'RESERVA_PDR', 'SAIDA_PDR'];
			newState.filtro.pagina = 0;
			this.setState(newState);

			/* Forma de resetar os valores formulário da pesquisa avançada */
			if (wasAvancada) {
				this.setState({ pesquisaAvancada: false });
				this.setState({ pesquisaAvancada: true });
			}
		}

		const { filtro } = this.state;
		const historicoTransacoes = await historicoDacaService.findByFiltro(filtro);

		this.setState({
			lista: historicoTransacoes.data,
		});
	}


	render() {
		const {
			state: {
				lista,
				daca,
			},
		} = this;

		return (
			<React.Fragment>
				<div className='row container mt-3 d-flex align-items-center'>
					<div className='col-md-12'>
						{this.pesquisaSimples()}
					</div>
					<div className='col-md-12'>
						{this.pesquisaAvancada()}
					</div>
				</div>
				<div className='row container mt-3 mb-3'>
					<Can
						perform={DACA_PERMISSIONS.GERENCIAR_ITEM}
						yes={() => (
							<Table
								align='left'
								columns={this.columnsHistorico}
								data={lista.content}
								onChangePage={page => this.handlePageChangeHistorico(page)}
								totalPages={lista.totalPages}
								currentPage={lista.pageable.pageNumber}
								emptyMessage='Não há itens cadastrados.'
								emptyColSpan={this.columnsHistorico.length > 0
									? this.columnsHistorico.length + 1 : this.columnsHistorico.length}
								showPaginate
								totalElements={lista.totalElements}
								totalItemPages={lista.content.length}
								trClass={historico => (historico.cancelado ? 'cancelado' : '')}
								/* Booleano para mostrar ou não o total da coluna quantidade */
								showTotal={false}
								actions={this.actionsHistorico}
								isDacaPermanent={daca.permanente}
								permission={DACA_PERMISSIONS.GERENCIAR_ITEM}
							/>
						)}
						no={() => (
							<Table
								align='left'
								columns={this.columnsHistorico}
								data={lista.content}
								onChangePage={page => this.handlePageChangeHistorico(page)}
								totalPages={lista.totalPages}
								currentPage={lista.pageable.pageNumber}
								emptyMessage='Não há itens cadastrados.'
								emptyColSpan={this.columnsHistorico.length > 0
									? this.columnsHistorico.length + 1 : this.columnsHistorico.length}
								showPaginate
								totalElements={lista.totalElements}
								totalItemPages={lista.content.length}
								trClass={historico => (historico.cancelado ? 'cancelado' : '')}
								/* Booleano para mostrar ou não o total da coluna quantidade */
								showTotal={false}
								actions={this.actionsHistoricoVisualizar}
								isDacaPermanent={daca.permanente}
								permission={DACA_PERMISSIONS.VISUALIZAR}
							/>
						)}
					/>
				</div>
				{this.createModalVisualizar()}
				{this.createModalEditarTransacao(this.state)}
				{this.createModalCancelarTransacao(lista.content ? lista.content[0] : null, this.state)}
			</React.Fragment>
		);
	}
}

export default ListarHistoricoDaca;
